import {Either} from 'shared/web';

type Quantity = {
  newQuantity: number;
};

type QuantityError = {
  hasError: boolean;
};

/**
 * Carried on every quantity report, alongside either the flushed quantity or the error state.
 *
 * True from the keystroke that makes the input diverge from the server value until the
 * debounced request is dispatched. Lets the basket owner block actions that would commit
 * the basket while an edit is still sitting in the debounce.
 */
type PendingQuantityChange = {
  hasPendingQuantityChange: boolean;
};

export type EitherQuantityOrError = Either<Quantity, QuantityError> & PendingQuantityChange;
